const SUPPORT_COLORS = ["white", "red", "#00ff00", "#9155fd"];

export { SUPPORT_COLORS };
export default { SUPPORT_COLORS };
